import { ReactElement } from "react";
import { Icon, H5, H6 } from "@sellar-io/components";

export type OrderAddressProps = {
  address: {
    name: string;
    street: string;
    city: string;
    region: string | null;
    postalCode: string;
    country: string;
  };
  onEditClick?: () => void;
  title?: string;
};

export const OrderAddress = (props: OrderAddressProps): ReactElement => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex justify-between">
        {props.title ? <H5>{props.title}</H5> : null}
        {props.onEditClick && (
          <div
            className="cursor-pointer print:hidden"
            onClick={props.onEditClick}
          >
            <Icon icon="PENCIL" />
          </div>
        )}
      </div>
      <div className={"select-text"}>
        <H6>{props.address.name}</H6>
        <H6>{props.address.street}</H6>
        <H6>{props.address.city}</H6>
        <H6>{props.address.region}</H6>
        <H6>
          {props.address.postalCode}, {props.address.country}
        </H6>
      </div>
    </div>
  );
};
